import React, {useState} from "react";
import {Icon} from "antd";
import {Link} from "react-router-dom";

import i18n from "../../i18n";
import PlatformNewsLink from "../header/PlatformNewsLink";
import {
    isPlatformNewsPath,
} from "../../presentation/public-site/route-policy";
import SubMenu from "./SubMenu";

function hasActivePath(item, currentPath) {
    return (
        Array.isArray(item.links) &&
        item.links.includes(currentPath)
    );
}

function MobileNavigationItem({
                                  item,
                                  currentPath,
                                  onNavigate,
                              }) {
    const [opened, setOpened] = useState(false);

    const hasActiveChild =
        Array.isArray(item.subItems) &&
        item.subItems.some(
            (subItem) =>
                Array.isArray(subItem.links) &&
                subItem.links.includes(currentPath)
        );

    if (
        !item.isDropdown ||
        !Array.isArray(item.subItems)
    ) {
        const path = Array.isArray(item.links)
            ? item.links[0]
            : null;

        if (!path) {
            return null;
        }

        return (
            <li
                className={
                    hasActivePath(item, currentPath)
                        ? "active"
                        : ""
                }
            >
                <Link
                    to={path}
                    onClick={() => onNavigate(path)}
                >
                    {i18n.t(
                        `main.header.menu.${item.langKey}`
                    )}
                </Link>
            </li>
        );
    }

    return (
        <li
            className={`mobile-dropdown-item${
                hasActiveChild ? " active" : ""
            }${opened ? " open" : ""}`}
        >
            <button
                type="button"
                className="mobile-dropdown-trigger"
                onClick={() => setOpened((value) => !value)}
                aria-expanded={opened}
            >
                <span>
                    {i18n.t(
                        `main.header.menu.${item.langKey}`
                    )}
                </span>

                <Icon
                    type={opened ? "up" : "down"}
                    className="mobile-dropdown-icon"
                />
            </button>

            {opened && (
                <ul className="mobile-dropdown-submenu">
                    {item.subItems.map((subItem) => {
                        const path = subItem.links[0];

                        return (
                            <li
                                key={path}
                                className={
                                    hasActivePath(
                                        subItem,
                                        currentPath
                                    )
                                        ? "active"
                                        : ""
                                }
                            >
                                <Link
                                    to={path}
                                    onClick={() =>
                                        onNavigate(path)
                                    }
                                >
                                    {i18n.t(
                                        `main.header.menu.${subItem.langKey}`
                                    )}
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            )}
        </li>
    );
}

export default function MobileNavigation({
                                             opened,
                                             items = [],
                                             user,
                                             currentPath,
                                             onNavigate,
                                             onClose,
                                         }) {
    if (!opened) {
        return null;
    }

    const handleNavigationClick = (event) => {
        if (event.target.closest("a")) {
            onClose();
        }
    };

    return (
        <div
            className="header__block header__block--mobile"
            id="mobile-navigation"
        >
            <div className="header__mobile-menu container">
                <div
                    className="head-nav"
                    onClick={handleNavigationClick}
                >
                    {items.length > 0 && (
                        <ul>
                            {items.map((item, index) => (
                                <MobileNavigationItem
                                    key={`${item.langKey}-${index}`}
                                    item={item}
                                    currentPath={currentPath}
                                    onNavigate={onNavigate}
                                />
                            ))}
                        </ul>
                    )}

                    <SubMenu user={user}>
                        <li
                            className={
                                isPlatformNewsPath(currentPath || "")
                                    ? "active"
                                    : ""
                            }
                        >
                            <PlatformNewsLink
                                className="header__mobile-news-link"
                                onClick={() => onNavigate("/news")}
                            />
                        </li>
                    </SubMenu>
                </div>
            </div>
        </div>
    );
}
